import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eADMIN_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCount = (params) => {
	return (dispatch) => {
		return HttpApi.get('GET_ACCOUNT_COUNT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getById = (params) => {
	return (dispatch) => {
		return HttpApi.get('', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};
export const getCodeResult = (params) => {
	return (dispatch) => {
		return HttpApi.get('eADMIN_PRODUCT_CODE_RESULT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const createProductCode = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_PRODUCT_CODE_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const createProductCode2 = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_PRODUCT_CODE_CREATE2', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const sendPushToAll = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_SEND_PUSH_TO_ALL', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};
//////////////////
///// PUT  ///////
//////////////////
export const updateAdmin = (params) => {
	return (dispatch) => {
		return HttpApi.put('eADMIN_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateStatus = (params) => {
	return (dispatch) => {
		return HttpApi.put('eADMIN_UPDATE_EUserStatus', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// DELETE /////
//////////////////
export const remove = () => {
    return (dispatch) => {
        return HttpApi.del('eADMIN_DELETE')
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

//////////////////
/// FUNCTIONS ////
//////////////////

export const login = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_LOGIN', params)
			.then((response) => {
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
/// FUNCTIONS ////
//////////////////
export const session = () => {
    return (dispatch) => {
        return HttpApi.get('eSESSION')
            .then((response) => {
            	console.log(response);
                dispatch({ type: ActionTypes.eADMIN, eADMIN: response.data });
                return Promise.resolve(response.data);
            })
            .catch((err) => {
            	console.log(err);
                return Promise.reject(err);
            });
    };
};
export const setAdmin = (params) => {
	return (dispatch) => {
		dispatch({ type: ActionTypes.eADMIN, eADMIN: params });
		return true;
	}
}

